/* eslint-disable react/destructuring-assignment */
import { SVGProps } from 'react';

const DetailsArrow = (props: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      data-palette="DetailsArrow">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="M0 0L16 0 16 16 0 16z"
                    transform="translate(-1274 -203) translate(822 137) translate(10.5 10) translate(106.5 52) translate(335 4)"
                  />
                  <path
                    fill="var(--brand-bg-primary)"
                    fillRule="nonzero"
                    d="M8.781 8L5.481 4.7 6.424 3.757 10.667 8 6.424 12.243 5.481 11.3z"
                    transform="translate(-1274 -203) translate(822 137) translate(10.5 10) translate(106.5 52) translate(335 4)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export default DetailsArrow;
